import { Buffer } from 'buffer';

// Ensure Buffer is available globally
if (typeof window !== 'undefined') {
    (window as any).Buffer = Buffer;
    (window as any).process = { env: {} };
}

// Export Buffer for use in other files
export { Buffer }; 